import PropTypes from "prop-types";
import { Component } from "react";

import { PLUGIN_LOGO_ICON_COMPONENTS } from "metabase/plugins";

import MobiFoneLogo from "./mobifone-logo.png";

export class DefaultLogoIcon extends Component {
  static defaultProps = {
    height: 32,
  };
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    dark: PropTypes.bool,
    fill: PropTypes.string,
  };

  render() {
    const { height, width } = this.props;
    // Calculate width based on aspect ratio if only height is provided
    // MobiFone logo aspect ratio is ~6.34:1 (325.26 / 51.3)
    const logoWidth = width || (height ? height * 6.34 : 32 * 6.34);

    return (
      <img
        src={MobiFoneLogo}
        alt="Logo"
        width={logoWidth}
        height={height}
        data-testid="main-logo"
      />
    );
  }
}

export default function LogoIcon(props) {
  const [Component = DefaultLogoIcon] = PLUGIN_LOGO_ICON_COMPONENTS;
  return <Component {...props} />;
}
